import type { CurrentUser } from '@wundo/client/auth.ts';

/**
 * What to call somebody on screen. Both names when there are two, whichever
 * one there is when there is one, and the address when there is neither — a
 * user record guarantees none of them.
 */
export function personName(user: CurrentUser): string {
  return [user.first_name, user.last_name].filter(Boolean).join(' ') || user.email || '';
}
